import React from "react";
import { useNavigate } from "react-router-dom";
import "./HeroSection1.css";
import Footer from "./Footer";
import './StatsSection.css';
import StatsSection from './StatsSection'; 
import Header from "./Header"; 
import PartnerSection from "./PartnerSection";
import heroVideo from "../videos/FC.mp4";
import impactVideo from "../videos/IWMI_July.mp4"; // Make sure this path is correct
import FloatingChat from "./FloatingChat";


const HeroSection1 = () => {
  const navigate = useNavigate();

  return (
    <div className="homepage-container">
      <Header />

      <main className="main-content">
        {/* Hero Section */}
        <div className="hero">
          <video autoPlay loop muted playsInline className="background-video">
            <source src={heroVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className="hero-content">
            <button className="btn" onClick={() => navigate("/map")}>
              Let's Explore Map
            </button>
          </div>
          
        </div>
           
        {/* Stats and Partner Sections */}
        <div className="no-gap">
          <StatsSection />
      
        </div>

        {/* Impact Section */}
       <div className="no-gaps">
           <PartnerSection />
      
        </div>
         
             <div
    style={{
      position: 'fixed',
      bottom: 24,
      display: 'flex',
      right: 24,    
      justifyContent: 'flex-end',
      zIndex: 20
    }}
  >
    <FloatingChat apiBase="http://localhost:5000" 
      openInitial={true}          // 👈 opens immediately on page load
    autoGreet={true}            // 👈 bot speaks first
    greetingText="👋 Welcome to DIWASA. Need help finding datasets or the map?" />
  </div>

      </main>
    
      <Footer />
    </div>
  );
};

export default HeroSection1;
